var _path, _rect, _circle, _circle2, _circle3, _path2, _circle4, _circle5, _circle6, _rect2, _rect3, _rect4, _rect5, _path3, _circle7, _path4, _circle8, _path5, _path6, _circle9, _circle10, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaqImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 415,
    height: 343,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6 296V154H120v28.8H56.4v30.6h52.4V240H56.4v56H23.6Zm139.902-142h35.4l48.8 142h-33.6l-11-31.8h-44.2l-10.8 31.8h-33.6l49-142Zm34.2 87.6-16.6-54.6-17 54.6h33.6Zm120.52 55.4c-10.667 0-20.333-2-29-6-8.533-4-15.933-9.4-22.2-16.2-6.133-6.933-10.867-14.667-14.2-23.2-3.333-8.667-5-17.6-5-26.8 0-9.467 1.733-18.467 5.2-27 3.6-8.667 8.533-16.333 14.8-23 6.4-6.667 13.933-11.933 22.6-15.8 8.667-4 18.133-6 28.4-6 10.533 0 20.067 2.067 28.6 6.2 8.667 4.133 16.067 9.667 22.2 16.6 6.267 6.933 11.067 14.733 14.4 23.4 3.333 8.533 5 17.267 5 26.2 0 9.467-1.733 18.467-5.2 27-3.467 8.533-8.4 16.2-14.8 23-6.4 6.667-13.933 11.933-22.6 15.8-8.533 3.867-17.933 5.8-28.2 5.8Zm.2-29.2c6.267 0 11.733-1.2 16.4-3.6 4.667-2.533 8.533-5.8 11.6-9.8 3.067-4.133 5.333-8.733 6.8-13.8 1.6-5.2 2.4-10.467 2.4-15.8 0-5.467-.8-10.733-2.4-15.8-1.6-5.2-4-9.8-7.2-13.8s-7.133-7.133-11.8-9.4c-4.667-2.4-9.933-3.6-15.8-3.6-6.267 0-11.733 1.267-16.4 3.8-4.533 2.4-8.4 5.667-11.6 9.8-3.067 4-5.4 8.6-7 13.8a55.813 55.813 0 0 0-2.2 15.6c0 5.467.8 10.733 2.4 15.8 1.6 5.067 3.933 9.667 7 13.8 3.2 4 7.133 7.2 11.8 9.6 4.667 2.267 10 3.4 16 3.4Zm-8.8-27.8h30.8l50.6 56h-30.8l-50.6-56Z",
    fill: "url(#a)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 101,
    width: 61,
    height: 22,
    rx: 11,
    fill: "#86CECE"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 157,
    cy: 112,
    r: 3,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 166,
    cy: 112,
    r: 3,
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 175,
    cy: 112,
    r: 3,
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m49.395 159.869-9.036-9.036a.997.997 0 0 0-.802-.288l-30.108 2.867a8.006 8.006 0 0 1-1.844-.025c-4.416-.603-6.355-1.834-7.355-5.463-.168-.609-.224-1.242-.224-1.873V124c-.304-7.659 2.057-9.235 7.672-9.909a8.17 8.17 0 0 1 1.655-.022l41.173 3.431c4.487.21 6.352 1.455 7.648 5.335.255.765.352 1.574.352 2.381V138.5c-.227 8.252-2.995 10.336-10.225 10.915-.647.052-1.093.684-.904 1.305l2.663 8.749c.121.399-.371.694-.666.4Z",
    fill: "#046384"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 134,
    r: 3,
    fill: "#fff"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 134,
    r: 3,
    fill: "#fff"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 134,
    r: 3,
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 90,
    width: 50,
    height: 18,
    rx: 9,
    fill: "#046384"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 275,
    y: 94,
    width: 40,
    height: 2,
    rx: 1,
    fill: "#fff",
    fillOpacity: 0.9
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 275,
    y: 98,
    width: 40,
    height: 2,
    rx: 1,
    fill: "#fff",
    fillOpacity: 0.9
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 293,
    y: 102,
    width: 22,
    height: 2,
    rx: 1,
    fill: "#fff",
    fillOpacity: 0.9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M218.321 51.508c12.47 6.547-3.213 20.866-1.65 31.01.071.465.679.502.878.075 2.992-6.391 10.935-15.428 13.862-24.566 1.461-4.56.333-9.684-3.084-13.038-6.345-6.227-15.46-6.386-20.926-1.805-4.583 3.841-4.508 11.136-1.217 16.129 4.086 6.2 9.958 4.662 10.746-6.967.047-.7.769-1.165 1.391-.838Z",
    fill: "#49D3D3"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 217,
    cy: 89.888,
    r: 3,
    fill: "#49D3D3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M394.795 260.738c18.446 9.092-4.566 29.62-1.708 43.865.092.462.705.495.897.065 4.243-9.528 16.973-23.505 20.243-37.346 1.101-4.661-.09-9.621-3.139-13.313-9.765-11.826-25.946-11.473-33.43-2.069-3.724 4.679-3.462 11.383-.94 16.804 5.636 12.114 15.625 11.252 16.667-7.146.04-.701.781-1.17 1.41-.86Z",
    fill: "#A6E5E5"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 393.449,
    cy: 314.303,
    r: 4.168,
    fill: "#A6E5E5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M270.152 212.535c.724 13.157-19.808 26.274-21.391 39.273-.057.468.515.696.835.351 7.894-8.499 26.674-18.608 34.898-32.136 2.488-4.091 2.969-9.136 1.405-13.661-5.757-16.651-23.62-22.252-34.896-14.358-4.898 3.429-6.955 9.79-6.124 15.712 1.507 10.741 9.409 13.101 14.994 5.617 3.228-4.327 9.982-6.188 10.279-.798Z",
    fill: "#046384"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M247.286 202.285c2.264-5.223 3.678-8.825 8.877-9.889.849-.174 1.397.826.988 1.59-1.865 3.493-1.14 6.777-.902 11.007.083 1.49-.244 3.018-1.22 4.146-2.384 2.754-5.612 3.143-7.781-.002-1.376-1.995-.926-4.628.038-6.852Z",
    fill: "#5EE7E7"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 245.665,
    cy: 261.857,
    r: 4.574,
    transform: "rotate(19.144 245.665 261.857)",
    fill: "#0C8B8B"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 262.03,
    cy: 192.315,
    r: 2,
    transform: "rotate(19.144 262.03 192.315)",
    fill: "#5EE7E7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M387.07 119.002a3.002 3.002 0 0 0-.933.223h-.004c-.285.113-1.64.683-3.7 1.547l-7.382 3.109c-5.297 2.23-10.504 4.426-10.504 4.426l.062-.024s-.359.118-.734.375a2.043 2.043 0 0 0-.586.567c-.184.27-.332.683-.277 1.11.09.722.558 1.155.894 1.394.34.242.664.355.664.355h.008l4.883 1.645c.219.703 1.488 4.875 1.793 5.836.18.574.355.933.574 1.207.106.14.23.257.379.351.077.045.16.081.246.106l-.05-.012c.015.004.027.016.038.02.04.011.067.015.118.023.773.234 1.394-.246 1.394-.246l.035-.028 2.883-2.625 4.832 3.707.11.047c1.007.442 2.027.196 2.566-.238.543-.437.754-.996.754-.996l.035-.09 3.734-19.129c.106-.472.133-.914.016-1.343a1.814 1.814 0 0 0-.781-1.047 1.88 1.88 0 0 0-1.067-.27Zm-.101 2.05c-.004.063.008.056-.02.177v.011l-3.699 18.93c-.016.027-.043.086-.117.145-.078.062-.14.101-.465-.028l-5.91-4.531-3.57 3.254.75-4.79 9.656-9c.398-.37.265-.448.265-.448.028-.454-.601-.133-.601-.133l-12.176 7.543-.004-.02-5.836-1.965v-.004l-.015-.003a.188.188 0 0 0 .03-.012l.032-.016.031-.011s5.211-2.196 10.508-4.426c2.652-1.117 5.324-2.242 7.379-3.11a741.045 741.045 0 0 1 3.66-1.53c.082-.032.043-.032.102-.032v-.001Z",
    fill: "#37B9B9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.517.003c.42.03.832.127 1.22.287h.006c.373.145 2.145.877 4.84 1.987l9.655 3.995c6.928 2.865 13.739 5.687 13.739 5.687l-.081-.031s.47.151.96.482c.303.19.564.437.767.728.24.347.434.878.362 1.426-.118.928-.73 1.485-1.17 1.791-.444.311-.868.457-.868.457h-.01l-6.387 2.113c-.287.903-1.947 6.264-2.346 7.499-.235.737-.464 1.198-.75 1.55-.14.18-.301.33-.496.451-.102.058-.21.104-.322.137l.065-.016c-.02.006-.035.02-.05.026-.052.014-.087.02-.154.03-1.01.3-1.823-.317-1.823-.317l-.046-.035-3.77-3.373-6.32 4.763-.145.06c-1.317.568-2.651.252-3.356-.306a3.358 3.358 0 0 1-.986-1.28L28.005 28 23.12 3.421c-.139-.607-.174-1.175-.021-1.726A2.326 2.326 0 0 1 24.12.35c.42-.25.906-.371 1.396-.347Zm.132 2.634c.005.081-.01.072.026.227v.015L30.514 27.2c.02.035.056.11.153.186.102.08.183.13.608-.036l7.73-5.821 4.67 4.18-.981-6.154-12.63-11.564c-.52-.475-.347-.575-.347-.575-.037-.584.786-.171.786-.171l15.926 9.692.005-.026 7.634-2.525v-.005l.02-.004a.348.348 0 0 1-.04-.015l-.041-.02-.041-.015-13.744-5.687c-3.47-1.435-6.964-2.88-9.652-3.996-1.594-.659-3.19-1.314-4.787-1.966-.108-.04-.057-.04-.134-.04v-.002Z",
    fill: "#009688"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 171.5,
    y1: 129.5,
    x2: 261.5,
    y2: 329.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B8B8B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqImage);
export default __webpack_public_path__ + "static/media/faq_image.ce88e958b32c5ff0854f65059d86003b.svg";
export { ForwardRef as ReactComponent };